let TAB_ID = '';

/**
 * Returns short a unique tab identifier for the current browser tab, which stays stable now matter how many times the function is called.
 * On the server side, it returns a constant empty string.
 */
export const getStableTabId = () => {
  if (!process.browser) {
    return TAB_ID;
  }
  if (!TAB_ID) {
    TAB_ID = Math.random().toString(36).substring(2, 15);
  }
  return TAB_ID;
};
